import { connect } from 'react-redux';
import { changeStations } from '../../../store/stations/changeStations';
import { IApplicationState, TTypedThunkDispatch } from '../../../types/store';

import { StationList } from './StationList';
import { IStationModel } from '../../../store/stations';
import { getDirectionGroupedStations } from '../../../utils/stations';
import { IGetVillageListResponseSchema } from '../../../../node/repositories/countryside-search/entities/entities/GetVillageListResponseSchema';

export interface IStationListProps {
  groupedStations: { [key: number]: IStationModel[] };
  selectedStations: number[];
  stationData: IGetVillageListResponseSchema['stationData'];
  stationDistance: number;
}

export interface IStationListDispatchProps {
  onChangeSelectedStations(value: number[], checked: boolean): void;
}

export type TStationListProps = IStationListProps & IStationListDispatchProps;

export function mapStateToProps(state: IApplicationState): IStationListProps {
  const {
    stations: { currentStations, selectedDirection, selectedStations = [], stationDistance },
    villageList: { stationData },
  } = state;

  return {
    groupedStations: getDirectionGroupedStations(currentStations, selectedDirection),
    selectedStations,
    stationData,
    stationDistance,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IStationListDispatchProps {
  return {
    onChangeSelectedStations: (value, checked) => dispatch(changeStations(value, checked)),
  };
}

export const StationListContainer = connect<IStationListProps, IStationListDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(StationList);
